import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import FontAwesome from 'react-fontawesome'
import numeral from 'numeral'
import moment from 'moment'

import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'

import { showHideModalAddFactura, downloadFile } from '../../actions/common'

import { updateInputs, removeFactura } from '../../actions/documentos'

import { isAllowedToViewComponent, formatcoin } from '../../utils/helpers'

class AttachedInvoicesBox extends Component {
    render() {
        
        const { facturas, documento, url, type, saldo, user, por_recibir, divisa } =this.props

        const totalFactura = {
            valor_sin_iva: facturas.reduce((acc, current) => acc+current.get('valor_sin_iva'), 0),
            valor_total: facturas.reduce((acc, current) => acc+current.get('valor_con_iva'), 0),
            anticipo_descontado: facturas.reduce((acc, current) => acc+current.get('amortizacion'), 0),
            valor_a_pagar: facturas.reduce((acc, current) => acc+current.get('valor_a_pagar'), 0)
        }

        let buttons = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.showHideModalAddFactura(true, documento, url, type, saldo) } title="Adicionar factura" disabled={ documento.get('estado') == 11 || por_recibir }  />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" onClick={ e => this.props.removeFactura() } title="Eliminar factura" disabled={ (facturas && facturas.filter(x => x.get('selected')).count() === 0) } danger/>,
        ]

        // if (!isAllowedToViewComponent('responsables_ingreso', documento, user.get('id')) || documento.get('estado') === 11) buttons = []

        if (!isAllowedToViewComponent('responsable_almacen', documento, user.get('id'))) buttons = []

        return (
            <BoxSection title="Facturas" actions={ buttons }>
                <table className="table table-condensed table-bordered table-striped table-sorted nowrap">
                    <thead>
                        <tr>
                            <th width="20px"></th>
                            <th style={{ width: '10%' }}>Número</th>
                            <th style={{ width: '10%' }}>Fecha de la factura</th>
                            <th style={{ width: '15%' }}>Fecha de radicación</th>
                            <th style={{ width: '15%' }}>Código de radicación</th>
                            <th style={{ width: '10%' }}>Valor sin IVA</th>
                            <th style={{ width: '10%' }}>Valor total</th>
                            <th style={{ width: '10%' }}>Ant. Descontado</th>
                            <th style={{ width: '5%' }}>Ant %</th>
                            <th style={{ width: '10%' }}>Valor pagado</th>
                            <th style={{ width: '5%' }}>Archivo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (facturas &&  facturas.count() > 0) ?
                                facturas.map((x, n) => {
                                    return (                                        
                                        <tr key={ `tr[24][${n}][${x.get('guid')}]` } className={ x.get('selected') ? 'info' : '' }>
                                            <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`modalSummary.data.facturas.${n}.selected`, e.target.checked) } /></td>
                                            <td>{ x.get('numero_factura') }</td>
                                            <td style={{ textAlign: 'right' }}>{ moment(x.get('fecha_factura')).format('YYYY-MM-DD') }</td>
                                            <td style={{ textAlign: 'right' }}>{ moment(x.get('fecha_radicacion')).format('YYYY-MM-DD') }</td>
                                            <td>{ x.getIn(['radicado', 'codigo']) }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('valor_sin_iva')), divisa.simbolo)  }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('valor_con_iva')), divisa.simbolo)  }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('amortizacion')), divisa.simbolo)  }</td>
                                            <td style={{ textAlign: 'right' }}>{ numeral(x.get('porcentaje_amortizacion')/100).format('0.0%') }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('valor_a_pagar')), divisa.simbolo)  }</td>
                                            <td style={{ textAlign: 'center' }}>
                                                {
                                                    (x.get('adjunto') &&
                                                        <span style={{ cursor: 'pointer' }}>
                                                            <FontAwesome name="download" onClick={ e => this.props.downloadFile(x.getIn(['adjunto', 'id']), x.getIn(['adjunto', 'nombre']) ) } />
                                                        </span>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                                <tr>
                                    <td colSpan={ 11 } style={{ textAlign: 'center' }}>Para adicionar facturas haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                </tr>
                        }

                        {
                            (facturas &&  facturas.count() > 0) && (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'right' , fontWeight: 'bold'}}>Totales</td>
                                    <td style={{ textAlign: 'right' }}>{formatcoin((totalFactura.valor_sin_iva), divisa.simbolo) }</td>
                                    <td style={{ textAlign: 'right' }}>{formatcoin((totalFactura.valor_total), divisa.simbolo) }</td>
                                    <td style={{ textAlign: 'right' }}>{formatcoin((totalFactura.anticipo_descontado), divisa.simbolo) }</td>
                                    <td></td>
                                    <td style={{ textAlign: 'right' }}>{formatcoin((totalFactura.valor_a_pagar), divisa.simbolo) }</td>
                                    <td></td>
                                </tr>

                            )
                        }

                    </tbody>
                </table>
            </BoxSection>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        url: state.documentos.getIn(['modalSummary', 'url']),
        type: state.documentos.getIn(['modalSummary', 'type']),
        documento: state.documentos.getIn(['modalSummary', 'data']),
        facturas: state.documentos.getIn(['modalSummary', 'data', 'facturas']),
        user: state.common.get('user')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalAddFactura: (show, documento, url, type, saldo) => dispatch(showHideModalAddFactura(show, documento, url, type, saldo)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        removeFactura: () => dispatch(removeFactura()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AttachedInvoicesBox)



// WEBPACK FOOTER //
// ./src/components/Shared/AttachedInvoicesBox.jsx